import React, { useState, useEffect, Fragment } from "react"
import { withSnackbar } from "notistack"
import { Button, CircularProgress, Grid, TextField, Radio, RadioGroup, FormControl, FormLabel, FormControlLabel, DialogTitle, DialogContent, DialogActions, Dialog } from "@material-ui/core"
import Autocomplete from "@material-ui/lab/Autocomplete"
import MomentUtils from "@date-io/moment"
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from "@material-ui/pickers"
import moment from "moment"
import { backendDateFormat, dayMonthDateFormat, fieldDMYShort } from "../../constants"
import { checkApiStatus } from "../../utils"
import { PageLoader } from "../../shared_elements"
import { UpdateAssetApi, UpdateEngine } from "../home/apiServices"
import { globalGetService } from "../../utils/globalApiServices"
import { regexConstants } from "../../constants/regEx"
import { aircraftCrud, engineCrud } from "../home/"
import { trackActivity } from "../../utils/mixpanel"
import CloseIcon from "@material-ui/icons/Close"
import { smbcInstance, acumenCamo } from "../../shared_elements/components"
import { isMobile } from "react-device-detect"
import EngOnOffWing from "./EngOnOffWing"

const BasicDetailForm = (props) => {
	const {
		open, closeUpdateForm, getResponseBack, fetchMntGrops, aircraftMntGrp, leaseStatus, subStatus,
		portfolios, lessees, operators, pltConstants, aircraftTypes,
		headerData, asset, LHData, RHData, assetType, basicDetailData, enqueueSnackbar
	} = props
  
	const [formSubmitLoader, setFormSubmitLoader] = useState(false)
	const [pageLoader, setPageLoader] = useState(false)
	const [data, setData] = useState(assetType == 1 ? aircraftCrud : engineCrud)
	const [error, setError] = useState({})
	const [slug, setSlug] = useState(null)
	const [engineList, setEngineList] = useState([])
	const [allEngine, setAllEngine] = useState([])
	const [engineData, setEngineData] = useState({
		lh_engine: LHData?.engine_type,
		Rh_engine: RHData?.engine_type
	})
	const [operatingThrust, setOperatingThrust] = useState([])

	useEffect(() => {
		// engineType
		globalGetService(`console/engine-types/`)
			.then(response => {
				if (checkApiStatus(response)) {
					setEngineList(response?.data?.data?.engineTypes)
				}
			})

		// getAllEngine
		if (headerData?.slug && assetType == 1) {
			globalGetService(`console/aircraft/${headerData.slug}/engine/`)
				.then(response => {
					if (checkApiStatus(response)) {
						setAllEngine(response?.data?.data)
					}
				})
		}
		// getAllOppThrust
		if (assetType == 2 || assetType === 2) {
			globalGetService(`camo/current_thrust/${assetType}/?engine_family_engine_type=${headerData?.engine_type?.engine_family_type_id}`)
				.then(response => {
					if (response?.status === 200) {
						setOperatingThrust(response?.data)
					}
				})
		}
		if (asset) {
			fillEditData()
			setSlug(headerData?.slug)
		}

		if (LHData) {
			const { esn, csn, tsn } = LHData
			setEngineData(prev => ({
				...prev,
				Lh_csn: csn,
				Lh_tsn: tsn,
				lh_esn: esn,
				lh_engine: LHData.engine_type
			}))
		}

		if (RHData) {
			const { esn, csn, tsn } = RHData
			setEngineData(prev => ({
				...prev,
				Rh_csn: csn,
				Rh_tsn: tsn,
				rh_esn: esn,
				Rh_engine: RHData.engine_type
			}))
		}
	}, [])

	const fillEditData = () => {
		if (asset === undefined || asset === null) {
			setData(null)
		} else {
			setData(headerData)
		}
	}

	const onFieldChange = (keyParam, value, date) => {
		if (keyParam === "aircraft_type") {
			if (value) {
				fetchMntGrops(value.id)
			}
			onFieldChange("maintenance_event_program_group", {})
		}
		if (date) {
			setError(prev => ({ ...prev, [keyParam]: "" }))
		}
		setData(prev => ({ ...prev, [keyParam]: value }))

		if (["lh_engine", "Rh_engine", "Lh_csn", "Rh_csn", "Lh_tsn", "Rh_tsn", "lh_esn", "rh_esn"].includes(keyParam)) {
			setEngineData(prev => ({ ...prev, [keyParam]: value }))
		}
	}

	const onRestErrorKey = (keyParam) => {
		setError(prev => ({ ...prev, [keyParam]: "" }))
	}

	const onUpdateAssetAndEngine = () => {
		const hasErrors = error?.date_of_manufacture
		if (hasErrors) {
			enqueueSnackbar("Please select Proper Date.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
			return
		}

		let validationInputs = {
			msn: assetType == 1 ? data?.msn ? "" : "Please enter msn" : '',
			aircraft_type: assetType == 1 ? data?.aircraft_type ? '' : "Please select Aircraft Type" : "",
			status: acumenCamo ? '' : assetType == 1 ? data?.status ? "" : "Please select status" : '',
			date_of_manufacture: acumenCamo ? '' : data?.date_of_manufacture ? "" : "Please select date of manufacture",
			portfolio: assetType == 1 ? data.ownership_type === 2 ? data.owner_portfolio ? "" : "Please select Portfolio" : "" : '',
			lessee: assetType == 1 ? data?.status?.value == 1 ? data?.lessee ? '' : "Please select lessee" : '' : '',
			operator: assetType == 1 ? data.same_operator_lessee ? "" : data?.operator?.id ? "" : "Please select operator" : '',
			tsn: (data?.tsn || data?.tsn === 0) ? '' : "Please Enter TSN",
			csn: (data?.csn || data?.csn === 0) ? '' : "Please Enter CSN",
			current_registration_number: (acumenCamo || assetType == 2 || data?.current_registration_number) ? '' : "Please Enter Registration"
		}

		if (Object.values(validationInputs).every(val => val === "")) {
			setFormSubmitLoader(true)
			const enginePromises = []
			allEngine?.length > 0 && allEngine?.forEach((engine) => {
				const payload = {
					is_titled: engine.is_titled,
					is_fitted: engine.is_fitted,
					...(([1, 3].includes(engine.position.value)
						? { engine_type: engineData.lh_engine?.id || null, csn: engineData.Lh_csn, tsn: engineData.Lh_tsn, esn: engineData.lh_esn }
						: [2, 4].includes(engine.position.value)
						? { engine_type: engineData.Rh_engine?.id || null, csn: engineData.Rh_csn, tsn: engineData.Rh_tsn, esn: engineData.rh_esn }
						: { engine_type: null, csn: null, tsn: null, esn: null }
					)),
				}
				const engineID = engine?.id
				const updatePromise = UpdateEngine(props, `console/aircraft/${slug}/engine/${engineID}/`, payload)
				enginePromises.push(updatePromise)
			})
			let assetPayload = Object.assign({}, data)
			let enginePayload = Object.assign({}, data)
			delete enginePayload.status
			assetPayload = {
				...assetPayload,
				aircraft_type: assetType == 1 && data.aircraft_type?.id,
				credit_classification: assetType == 1 && data.credit_classification && data.credit_classification.value ? data.credit_classification.value : null,
				maintenance_event_program_group: assetType == 1 && data.maintenance_event_program_group && data.maintenance_event_program_group.value ? data.maintenance_event_program_group.value : null,
				status: assetType == 1 && data?.status && data?.status?.value || null,
				sub_status: assetType == 1 ? data?.sub_status?.value : null,
				lessee: assetType == 1 && data.status?.value === 1 && data?.lessee ? data?.lessee : null,
				operator: assetType == 1 && data?.operator?.id ? data.operator?.id : null,
				id: assetType == 1 && asset,
				off_lease_status: assetType == 1 && typeof data.off_lease_status === "object" ? null : data.off_lease_status,
				country: assetType == 1 && data.country ? data.country : null,
				csn: +data.csn || null,
				tsn: +data.tsn || null,
			}
			enginePayload = {
				...enginePayload,
				csn: +data.csn || null,
				tsn: +data.tsn || null,
				manufacturing_date: data?.date_of_manufacture || null,
				current_operating_thrust: data.current_operating_thrust ? data.current_operating_thrust : null,
				engine_type: data?.engine_type?.id ? data?.engine_type?.id : null,
				current_operating_thrust_id: data.current_operating_thrust ? data.current_operating_thrust?.id : null
			}

			if (assetPayload.ownership_type === 2 && assetPayload.owner_portfolio.id) {
				assetPayload = { ...assetPayload, owner_portfolio: assetPayload.owner_portfolio.id }
			} else if (assetPayload.ownership_type === 1) {
				assetPayload = { ...assetPayload, owner_portfolio: null }
			}

			const updateAssetPromise = assetType == 1
				? UpdateAssetApi(props, `console/aircraft-overview/${slug}/`, assetPayload)
				: UpdateAssetApi(props, `console/engine/${slug}/details/`, enginePayload)

			let anyPromiseFailed = false
			let failedToastMessage = null

			Promise.all([...enginePromises, updateAssetPromise])
				.then(responses => {
					setFormSubmitLoader(false)
					responses.forEach(response => {
						if (!checkApiStatus(response) || response?.data?.status === 'FAIL') {
							anyPromiseFailed = true
							if (!failedToastMessage) {
								failedToastMessage = response?.data?.message
							}
						}
					})
					if (anyPromiseFailed) {
						enqueueSnackbar(failedToastMessage || "Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
					} else {
						enqueueSnackbar("Basic details updated successfully.", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } })
						trackActivity('CAMO', {
							event_type: 'Basic details updated successfully.',
							page_title: 'Basic Details',
							item_slug: slug ? slug : '',
							request_body: assetType == 1 ? assetPayload : enginePayload,
						})
						getResponseBack && getResponseBack()
						closeUpdateForm()
					}
				})
				.catch(error => {
					console.error('An error occurred:', error)
				})
		} else {
			setError(validationInputs)
			trackActivity('CAMO', {
				event_type: 'Basic details updated Failed',
				page_title: 'Basic Details',
				error_source: 'Frontend',
				error_type: validationInputs ? validationInputs : ''
			})
		}
	}

	let maintanenceList = []
	let maintanenceData = data?.maintenance_event_program_group
	if (maintanenceData) {
		Object.keys(maintanenceData).map((item) => {
			maintanenceList.push({ label: maintanenceData[item].replace(/,/g, '/'), value: item })
		})
	}

	return (
		<Dialog
			position="relative"
			maxWidth="lg"
			open={open}
			onClose={closeUpdateForm}
			style={{ height: isMobile && "650px" }}
		>
			<Fragment>
				<div id="AmpTaskForm">
					<DialogTitle className="just-center">
						{assetType == 1 ? "Update Aircraft" : "Update Engine"}
						<CloseIcon
							onClick={closeUpdateForm}
							className="close-icon"
						/>
					</DialogTitle>
					<DialogContent>
						<form>
							<Grid container spacing={2}>
								<Grid item xs={12} md={3}>
									{assetType == 1 ?
										<TextField
											required
											variant="outlined"
											id="msn"
											label="MSN"
											fullWidth
											margin="normal"
											value={data?.msn}
											error={error.msn ? true : false}
											helperText={error.msn ? error.msn : ""}
											onChange={(e, value) => onFieldChange("msn", e.target.value)}
											onFocus={() => onRestErrorKey("msn")}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
										/>
										:
										<TextField
											variant="outlined"
											id="esn"
											label="ESN"
											fullWidth
											margin="normal"
											value={data?.esn}
											error={error.esn ? true : false}
											helperText={error.esn ? error.esn : ""}
											onChange={(e, value) => onFieldChange("esn", e.target.value)}
											onFocus={() => onRestErrorKey("esn")}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled
										/>}
								</Grid>
								<Grid item xs={12} md={3}>
									{assetType == 1 ?
										<Autocomplete
											className="autoComp"
											options={aircraftTypes}
											getOptionLabel={(option) => option?.name}
											id="aircraft_type"
											value={data?.aircraft_type || ''}
											onChange={(e, value) => onFieldChange("aircraft_type", value)}
											renderInput={(params) => (
												<TextField
													{...params}
													variant="outlined"
													required={true}
													error={error.aircraft_type ? true : false}
													helperText={error.aircraft_type ? error.aircraft_type : ""}
													onFocus={() => onRestErrorKey("aircraft_type")}
													label="Type"
													margin="normal"
													InputLabelProps={{ shrink: true }}
													fullWidth
													placeholder="Select Type"
												/>
											)}
										/>
										:
										<TextField
											variant="outlined"
											value={data?.engine_type_name}
											label="Engine Type"
											margin="normal"
											fullWidth
											disabled
											InputLabelProps={{ shrink: true }}
										/>
									}
								</Grid>
								{assetType == 1 && <Grid item xs={12} md={3}>
									<TextField
										required={acumenCamo ? false : true}
										variant="outlined"
										id="current_registration_number"
										label="Registration"
										fullWidth
										margin="normal"
										value={data?.current_registration_number}
										onChange={(e, value) => onFieldChange("current_registration_number", e.target.value)}
										inputProps={{ maxLength: 20 }}
										InputLabelProps={{ shrink: true }}
										onFocus={() => onRestErrorKey("current_registration_number")}
										error={error.current_registration_number ? true : false}
										helperText={error.current_registration_number ? error.current_registration_number : " "}
									/>
								</Grid>}
								<Grid item xs={12} md={3}>
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											inputVariant="outlined"
											required={acumenCamo ? false : true}
											margin="normal"
											id="date_of_manufacture"
											label="Date of Manufacture"
											format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
											fullWidth
											disableFuture
											InputLabelProps={{ shrink: true }}
											minDate={moment().subtract(25, "years")}
											value={data?.date_of_manufacture || null}
											error={acumenCamo ? false : error.date_of_manufacture ? true : false}
											helperText={acumenCamo ? "" : error.date_of_manufacture ? error.date_of_manufacture : " "}
											onFocus={() => onRestErrorKey("date_of_manufacture")}
											onBlur={(e) => {
												const inputValue = e.target.value
												const isValid = moment(inputValue, acumenCamo ? fieldDMYShort : dayMonthDateFormat, true).isValid()
												if (isValid || inputValue === '') {
													setError("")
													onFieldChange('date_of_manufacture', inputValue === '' ? null : moment(e.target.value, acumenCamo ? fieldDMYShort : dayMonthDateFormat, true).format(backendDateFormat))
												} else {
													setError(prev => ({
														...prev,
														date_of_manufacture: "Invalid Date",
													}))
												}
											}}
											onChange={(date) => onFieldChange("date_of_manufacture", moment(date).isValid() ? moment(date).format(backendDateFormat) : null, 'date')}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								{assetType == 2 && <Grid item xs={12} md={3}>
									<Autocomplete
										options={operatingThrust ? operatingThrust : []}
										getOptionLabel={(option) => option?.name}
										id="current_operating_thrust"
										disabled
										value={{ name: data?.current_operating_thrust?.name || "" }}
										onChange={(e, value) => onFieldChange("current_operating_thrust", value)}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Op.Thrust (Current)"
												margin="normal"
												fullWidth
												InputLabelProps={{ shrink: true }}
												placeholder="Select Op.Thrust (Current)"
												variant="outlined"
											/>
										)}
									/>
								</Grid>}
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs={12} md={3}>
									<TextField
										required
										variant="outlined"
										id="tsn"
										label="TSN"
										fullWidth
										margin="normal"
										value={data?.tsn}
										error={error.tsn ? true : false}
										helperText={error.tsn ? error.tsn : ""}
										onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('tsn', e.target.value) : e.preventDefault() }}
										inputProps={{ maxLength: 10 }}
										InputLabelProps={{ shrink: true }}
										disabled={data?.utilization_data}
										onFocus={() => onRestErrorKey("tsn")}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<TextField
										required
										variant="outlined"
										id="csn"
										label="CSN"
										fullWidth
										margin="normal"
										value={data?.csn}
										error={error.csn ? true : false}
										helperText={error.csn ? error.csn : ""}
										onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange('csn', e.target.value) : e.preventDefault() }}
										inputProps={{ maxLength: 5 }}
										InputLabelProps={{ shrink: true }}
										disabled={data?.utilization_data}
										onFocus={() => onRestErrorKey("csn")}
									/>
								</Grid>
								{assetType == 1 && <Grid item xs={12} md={3}>
									<Autocomplete
										options={aircraftMntGrp ? aircraftMntGrp : []}
										getOptionLabel={(option) => option.label}
										id="maintenance_event_program_group"
										value={{ label: maintanenceList[0]?.label }}
										onChange={(e, value) => onFieldChange("maintenance_event_program_group", value)}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Maintenance Program Group"
												margin="normal"
												fullWidth
												InputLabelProps={{ shrink: true }}
												placeholder="Select Maintenance Group"
												variant="outlined"
											/>
										)}
									/>
								</Grid>}
								{assetType == 1 && <Grid item xs={12} md={3}>
									<Autocomplete
										options={pltConstants.filter(
											(item) => item.type === "credit_classification"
										)}
										getOptionLabel={(option) => option.label}
										id="credit_classification"
										value={data?.credit_classification}
										onChange={(e, value) => onFieldChange("credit_classification", value)}
										renderInput={(params) => (
											<TextField
												variant="outlined"
												{...params}
												label="Credit Classification"
												margin="normal"
												fullWidth
												InputLabelProps={{ shrink: true }}
												placeholder="Select Credit Classification"
											/>
										)}
									/>
								</Grid>}
								{assetType == 2 && <Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="tslv"
										label={smbcInstance ? 'TSPR' : 'TSLSV'}
										fullWidth
										margin="normal"
										value={data?.tslv ? (data?.tslv).toFixed(2) : ''}
										onChange={(e, value) => onFieldChange("tslv", e.target.value)}
										inputProps={{ maxLength: 20 }}
										disabled
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>}
								{assetType == 2 && <Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="cslv"
										label={smbcInstance ? 'CSPR ' : 'CSLSV'}
										fullWidth
										margin="normal"
										value={data?.cslv ? (data?.cslv).toFixed(2) : ''}
										onChange={(e, value) => onFieldChange("cslv", e.target.value)}
										inputProps={{ maxLength: 20 }}
										disabled
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>}
							</Grid>
							{assetType == 2 && <Grid container spacing={2}>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="llp_limiter"
										label="LLP Limiter(s)"
										fullWidth
										margin="normal"
										disabled
										value={data?.llp_limiter !== undefined && data?.llp_limiter !== null ? data.llp_limiter : ''}
										onChange={(e, value) => onFieldChange("llp_limiter", e.target.value)}
										inputProps={{ maxLength: 20 }}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="soft_time_limiter"
										label="Soft-time Limiter(s)"
										fullWidth
										margin="normal"
										disabled
										value={data?.soft_time_limiter !== undefined && data?.soft_time_limiter !== null ? data?.soft_time_limiter : ''}
										onChange={(e) => onFieldChange("soft_time_limiter", e.target.value)}
										inputProps={{ maxLength: 20 }}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											margin="normal"
											label="Reporting Month"
											format={dayMonthDateFormat}
											fullWidth
											disableFuture
											disabled
											InputLabelProps={{ shrink: true }}
											minDate={moment(data?.date_of_manufacture)}
											value={data?.last_utilization_updated ? data?.last_utilization_updated : null}
											error={false}
											helperText={''}
											onChange={(data, value) => onFieldChange('last_utilization_updated', moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
											inputVariant='outlined'
										/>
									</MuiPickersUtilsProvider>
								</Grid>
							</Grid>}
							{window?.location?.pathname.split("/").at(-2) === 'tech_spec' ? null : assetType == 2 && <Grid container spacing={2}>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="mcbr"
										label="MCBR"
										fullWidth
										margin="normal"
										disabled
										value={basicDetailData?.new_tec_spec?.smbc_forecast_mcbr || ''}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="mtbr"
										label="MTBR"
										fullWidth
										margin="normal"
										disabled
										value={basicDetailData?.new_tec_spec?.smbc_forecast_mtbr || ''}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="sv_interval_remaining"
										label="SV Interval Remaining"
										fullWidth
										margin="normal"
										disabled
										value={basicDetailData?.new_tec_spec?.sv_interval_remaining === null ? "N/A" : basicDetailData?.new_tec_spec?.sv_interval_remaining > 0 ? basicDetailData?.new_tec_spec?.sv_interval_remaining : '0'}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="sv_forecast_date"
										label="SV Forecast Date"
										fullWidth
										margin="normal"
										disabled
										value={basicDetailData?.new_tec_spec?.sv_forecast_date ? moment(basicDetailData?.new_tec_spec?.sv_forecast_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "N/A"}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<TextField
										variant="outlined"
										id="engine_operator"
										label="Operator"
										fullWidth
										margin="normal"
										disabled
										value={headerData?.operator?.name || ''}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item xs={12}>
									<Grid item md={6} sm={6} xs={12}>
										{(() => {
											let options = [{ label: 'On Wing', value: 1 }, { label: 'Off Wing', value: 2 }];
											return (
												<Autocomplete
													disableClearable
													disabled
													options={options}
													getOptionLabel={option => option?.label}
													name="on_wing_status"
													value={basicDetailData?.on_wing_status ? { label: 'On Wing', value: 1 } : { label: 'Off Wing', value: 2 }}
													renderInput={params => <TextField error={error?.on_wing_status} helperText={error?.on_wing_status || ''} {...params} label="Wing Status" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
												/>
											)
										})()}
									</Grid>
								</Grid>
							</Grid>}
							{assetType == 1 && <Grid container spacing={2}>
								<Grid item xs={12} md={4}>
									<Autocomplete
										options={leaseStatus ? leaseStatus?.filter((item => item.value !== 0)) : []}
										getOptionLabel={(option) => option?.label}
										id="status"
										value={data?.status || ''}
										onChange={(e, value) => onFieldChange("status", value)}
										renderInput={(params) => (
											<TextField
												variant="outlined"
												required={acumenCamo ? false : true}
												error={acumenCamo ? false : error.status ? true : false}
												helperText={acumenCamo ? "" : error.status ? error.status : ""}
												onFocus={() => onRestErrorKey("status")}
												{...params}
												label="Lease Status"
												margin="normal"
												fullWidth
												InputLabelProps={{ shrink: true }}
												placeholder="Select Lease Status"
											/>
										)}
									/>
								</Grid>
								<Grid item xs={12} md={4}>
									<Autocomplete
										options={subStatus ? subStatus : []}
										getOptionLabel={(option) => option.label}
										id="sub_status"
										value={data?.sub_status ? data.sub_status : null}
										onChange={(e, value) => onFieldChange("sub_status", value)}
										renderInput={(params) => (
											<TextField
												variant="outlined"
												onFocus={() => onRestErrorKey("sub_status")}
												{...params}
												label="Sub Status"
												margin="normal"
												fullWidth
												InputLabelProps={{ shrink: true }}
												placeholder="Select Sub Status"
											/>
										)}
									/>
								</Grid>
								<Grid item xs={12} md={4}>
									<Autocomplete
										options={lessees}
										getOptionLabel={(option) => option.name}
										id="lessee"
										value={data?.status?.value === 1 ? data.lessee : ''}
										disabled={data?.status?.value === 1 ? false : true}
										style={{ background: data?.status?.value === 1 ? '' : "#eeeeee" }}
										onChange={(e, value) => onFieldChange("lessee", value)}
										renderInput={(params) => (
											<TextField
												variant="outlined"
												error={data.status.value !== 1 ? false : error.lessee ? true : false}
												required={data?.status && data.status.value == 1 ? true : false}
												helperText={data.status.value !== 1 ? "" : error.lessee ? error.lessee : ""}
												onFocus={() => onRestErrorKey("lessee")}
												{...params}
												label="Lessee"
												margin="normal"
												fullWidth
												InputLabelProps={{ shrink: true }}
												placeholder="Select Lessee"
											/>
										)}
									/>
								</Grid>
							</Grid>}
							{assetType == 1 && <Grid container spacing={2}>
								<Grid item xs={12} md={4}>
									<TextField
										variant="outlined"
										id="country"
										label="Country"
										fullWidth
										margin="normal"
										value={data?.country}
										onChange={(e, value) => onFieldChange("country", e.target.value)}
										inputProps={{ maxLength: 50 }}
										InputLabelProps={{ shrink: true }}
										placeholder="Search Location"
									/>
								</Grid>
								<Grid item xs={12} md={4}>
									<FormControl component="fieldset">
										<FormLabel className="MuiInputLabel-shrink" component="label" id="form-label"> Ownership Status</FormLabel>
										<RadioGroup
											row
											aria-label="position"
											name="ownership_type"
											defaultValue="top"
										>
											<FormControlLabel
												value={1}
												control={
													<Radio
														checked={data?.ownership_type === 1}
														onChange={() => onFieldChange("ownership_type", 1)}
														color="primary"
														size="small"
													/>
												}
												label="Owned"
											/>
											<FormControlLabel
												value={2}
												control={
													<Radio
														checked={data?.ownership_type === 2}
														onChange={() => onFieldChange("ownership_type", 2)}
														color="primary"
														size="small"
													/>
												}
												label="Managed"
											/>
										</RadioGroup>
									</FormControl>
								</Grid>
								{data?.ownership_type === 2 ? (
									<Grid item xs={12} md={4}>
										<Autocomplete
											options={portfolios}
											getOptionLabel={(option) => option.name}
											id="owner_portfolio"
											value={data?.owner_portfolio}
											onChange={(e, value) => onFieldChange("owner_portfolio", value)}
											renderInput={(params) => (
												<TextField
													variant="outlined"
													error={error.portfolio ? true : false}
													required={true}
													helperText={error.portfolio ? error.portfolio : ""}
													onFocus={() => onRestErrorKey("portfolio")}
													{...params}
													label="Portfolio"
													margin="normal"
													fullWidth
													InputLabelProps={{ shrink: true }}
													placeholder="Select Portfolio"
												/>
											)}
										/>
									</Grid>
								) : null}
							</Grid>}

							{assetType == 1 && <Grid container spacing={2}>
								<Grid item xs={12} md={4}>
									<FormControl component="fieldset">
										<FormLabel className="MuiInputLabel-shrink" component="label"> Is Lessee also the Operator?</FormLabel>
										<RadioGroup row aria-label="position" name="same_operator_lessee" defaultValue="top">
											<FormControlLabel
												value="is_titled"
												control={
													<Radio
														onChange={() => {
															onFieldChange("same_operator_lessee", true)
															onRestErrorKey("operator")
														}}
														checked={data?.same_operator_lessee}
														color="primary"
														size="small"
													/>
												}
												label="Yes"
											/>
											<FormControlLabel
												value="is_fitted"
												control={
													<Radio
														onChange={() => {
															onFieldChange("same_operator_lessee", false)
															onRestErrorKey("operator")
														}}
														checked={!data?.same_operator_lessee}
														color="primary"
														size="small"
													/>
												}
												label="No"
											/>
										</RadioGroup>
									</FormControl>
								</Grid>
								{!data?.same_operator_lessee ? (
									<Grid item xs={12} md={4}>
										<Autocomplete
											options={operators}
											getOptionLabel={(option) => option.name}
											id="operator"
											value={data?.operator ? data?.operator : ''}
											onChange={(e, value) => onFieldChange("operator", value)}
											renderInput={(params) => (
												<TextField
													variant="outlined"
													required={!data?.same_operator_lessee ? true : false}
													error={error.operator ? true : false}
													helperText={error.operator ? error.operator : " "}
													onFocus={() => onRestErrorKey("operator")}
													{...params}
													label="Operator"
													margin="normal"
													fullWidth
													InputLabelProps={{ shrink: true }}
													placeholder="Select Operator"
												/>
											)}
										/>
									</Grid>
								) : null}
							</Grid>}
						</form>
						<hr />
						{assetType == 1 && allEngine?.length > 0 ?
							<form>
								<Grid container spacing={2}>
									<Grid item xs={12} md={3}>
										<Autocomplete
											className="autoComp"
											options={engineList}
											getOptionLabel={(option) => option.name}
											id="engine_name"
											value={engineData?.lh_engine}
											style={{ background: LHData?.engine_type ? '' : "#eeeeee" }}
											disabled={LHData?.engine_type ? false : true}
											onChange={(e, value) => onFieldChange("lh_engine", value)}
											renderInput={(params) => (
												<TextField
													{...params}
													variant="outlined"
													label="LH Engine Type/Model"
													margin="normal"
													fullWidth
													InputLabelProps={{ shrink: true }}
													placeholder="Select Type"
												/>
											)}
										/>
									</Grid>
									<Grid item xs={12} md={3}>
										<TextField
											variant="outlined"
											label="LH Engine TSN"
											fullWidth
											margin="normal"
											value={engineData?.Lh_tsn ? engineData?.Lh_tsn : ''}
											onChange={(e, value) => onFieldChange("Lh_tsn", e.target.value)}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled={LHData?.esn ? false : true}
											style={{ background: LHData?.esn ? '' : "#eeeeee" }}
										/>
									</Grid>
									<Grid item xs={12} md={3}>
										<TextField
											variant="outlined"
											label="LH Engine CSN"
											fullWidth
											margin="normal"
											value={engineData?.Lh_csn ? engineData?.Lh_csn : ''}
											onChange={(e, value) => onFieldChange("Lh_csn", e.target.value)}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled={LHData?.esn ? false : true}
											style={{ background: LHData?.esn ? '' : "#eeeeee" }}
										/>
									</Grid>
									<Grid item xs={12} md={3}>
										<TextField
											variant="outlined"
											label="LH Serial Number"
											fullWidth
											margin="normal"
											value={engineData?.lh_esn ? engineData?.lh_esn : ''}
											onChange={(e, value) => onFieldChange("lh_esn", e.target.value)}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled={LHData?.esn ? false : true}
											style={{ background: LHData?.esn ? '' : "#eeeeee" }}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={2}>
									<Grid item xs={12} md={3}>
										<Autocomplete
											className="autoComp"
											options={engineList}
											getOptionLabel={(option) => option.name}
											id="engine_name"
											value={engineData?.Rh_engine}
											disabled={RHData?.engine_type ? false : true}
											style={{ background: RHData?.engine_type ? '' : "#eeeeee" }}
											onChange={(e, value) => onFieldChange("Rh_engine", value)}
											renderInput={(params) => (
												<TextField
													{...params}
													variant="outlined"
													label="RH Engine Type/Model"
													margin="normal"
													fullWidth
													InputLabelProps={{ shrink: true }}
													placeholder="Select Type"
												/>
											)}
										/>
									</Grid>
									<Grid item xs={12} md={3}>
										<TextField
											variant="outlined"
											label="RH Engine TSN"
											fullWidth
											margin="normal"
											value={engineData?.Rh_tsn ? engineData?.Rh_tsn : ''}
											onChange={(e, value) => onFieldChange("Rh_tsn", e.target.value)}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled={RHData?.esn ? false : true}
											style={{ background: RHData?.esn ? '' : "#eeeeee" }}
										/>
									</Grid>
									<Grid item xs={12} md={3}>
										<TextField
											variant="outlined"
											label="RH Engine CSN"
											fullWidth
											margin="normal"
											value={engineData?.Rh_csn ? engineData?.Rh_csn : ''}
											onChange={(e, value) => onFieldChange("Rh_csn", e.target.value)}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled={RHData?.esn ? false : true}
											style={{ background: RHData?.esn ? '' : "#eeeeee" }}
										/>
									</Grid>
									<Grid item xs={12} md={3}>
										<TextField
											variant="outlined"
											label="RH Serial Number"
											fullWidth
											margin="normal"
											value={engineData?.rh_esn ? engineData?.rh_esn : ''}
											onChange={(e, value) => onFieldChange("rh_esn", e.target.value)}
											inputProps={{ maxLength: 20 }}
											InputLabelProps={{ shrink: true }}
											disabled={RHData?.esn ? false : true}
											style={{ background: RHData?.esn?.length ? '' : "#eeeeee" }}
										/>
									</Grid>
								</Grid>
							</form> : null}
					</DialogContent>
					<DialogActions>
						<Button color="primary" variant="contained" onClick={onUpdateAssetAndEngine}>
							{formSubmitLoader ? (<CircularProgress color="#ffffff" size={24} />) : ("SAVE CHANGES")}
						</Button>
						<Button color="primary" variant="contained" onClick={closeUpdateForm}>CLOSE</Button>
					</DialogActions>
				</div>
				{pageLoader ? <PageLoader /> : null}
			</Fragment>
		</Dialog>
	)
}

export default withSnackbar(BasicDetailForm)
